import { breakpoint } from '../mixins/breakpoints';
import { css } from 'styled-components';
import { span } from '../utils/grid';
import { showFor } from '../utils/visibility';

export default css`
  .layout-two-columns {
    grid-template-columns: 1fr;

    ${breakpoint('large')} {
      grid-template-columns: repeat(12, 1fr);
    }

    &__left {
      ${showFor('large')}
      ${span(2)}
    }

    &__right {
      ${span(10)}
      flex-grow: 1;
      ${breakpoint('large')} {
        grid-column: span 10;
      }
    }
  }
`;
